import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { ArrowIcon } from '@avila-tek/ui/src';
import { Category } from '../../models';

interface DraggableProductCardProps {
  category: Category;
  idx: number;
  updateItems: (idx: number, data: string) => void;
  moveCard: (dragIndex: any, hoverIndex: any) => void;
  selectedItemIds: string[];
  setSelectedItemIds: React.Dispatch<React.SetStateAction<string[]>>;
}

const type = 'Doc';

function DraggableCategory({
  category,
  idx,
  updateItems,
  moveCard,
  selectedItemIds,
  setSelectedItemIds,
}: DraggableProductCardProps) {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const [_id] = React.useState(category?._id);

  const [, drop] = useDrop({
    accept: type,
    hover(item) {
      if (!ref.current) {
        return;
      }
      const dragIndex = (item as any).idx as number;
      const hoverIndex = idx;
      if (dragIndex === hoverIndex) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      (item as any).idx = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type,
    item: () => ({ idx }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <div
      className={`w-full flex flex-row justify-between items-center gap-2 py-2 border-b-2 border-gray-100 cursor-pointer ${
        isDragging ? 'opacity-25' : 'opacity-100'
      }`}
      ref={ref}
    >
      <div className="min-w-[75%] flex flex-row gap-2">
        <p className="w-[85%] truncate font-title text-black  text-lg">
          {category?.name}
        </p>
      </div>
      <div className="flex flex-col">
        <ArrowIcon className="w-3 h-3 -rotate-90 " />
        <ArrowIcon className="w-3 h-3 rotate-90 " />
      </div>
    </div>
  );
}

export default DraggableCategory;
